import type { SideBarDef, ToolPanelDef } from '@cmg/data-grid';
import { useDataGridContext } from '@cmg/data-grid';
import { useMemo } from 'react';

const widthConfig = {
  width: 300,
  minWidth: 300,
  maxWidth: 300,
} as const;

const columnsToolPanelDef: ToolPanelDef = {
  id: 'columns',
  labelDefault: '',
  labelKey: 'columns',
  iconKey: 'columnsTab',
  toolPanel: 'agColumnsToolPanel',
  toolPanelParams: {
    suppressValues: true,
    suppressRowGroups: true,
    suppressPivotMode: true,
  },
  ...widthConfig,
};

const filtersToolPanelDef: ToolPanelDef = {
  id: 'filters',
  labelDefault: '',
  labelKey: 'filters',
  iconKey: 'filterTab',
  toolPanel: 'agFiltersToolPanel',
  ...widthConfig,
};

export const useSideBarDef = () => {
  const { getOpenedToolPanel } = useDataGridContext();
  const openedToolPanel = getOpenedToolPanel() ?? undefined;

  return useMemo<SideBarDef>(() => {
    return {
      toolPanels: [filtersToolPanelDef, columnsToolPanelDef],
      defaultToolPanel: openedToolPanel,
    };
  }, [openedToolPanel]);
};
